import api from './axios.js';

export const whatsappWebApi = {
  status: () => api.get('/whatsapp-web/status'),
  connect: () => api.post('/whatsapp-web/connect'),
  pairingCode: (phone) => api.post('/whatsapp-web/pairing-code', { phone }),
  checkNumber: (phone) => api.post('/whatsapp-web/check-number', { phone }),
  chats: () => api.get('/whatsapp-web/chats'),
  markRead: (contactId) => api.post(`/whatsapp-web/chats/${contactId}/read`),
  presence: (contactId, state) => api.post(`/whatsapp-web/chats/${contactId}/presence`, { state }),
  send: (data) => api.post('/whatsapp-web/send', data),
  sendImage: (data) => api.post('/whatsapp-web/send-image', data),
  sendDocument: (data) => api.post('/whatsapp-web/send-document', data),
  disconnect: () => api.post('/whatsapp-web/disconnect'),
};
